// 用户api
import request from "@/config/_request";
// import qs from "qs";

// 教师登录
export function login(params) {
    return request({
        url: "/java-api/school/tch/login",
        data: params,
        method: "post",
    });
}
// 学生登录
export function loginStu(params) {
    return request({
        url: "/java-api/student/stu/login",
        data: params,
        method: "post",
    });
}

/**
 * 教师端校区管理 刷新权限设置
 * @param {*} params 
 * @returns 
 */
export function api_schFreshAuthData(params) {
    return request({
        url: "/java-api/auth/sch/freshAuthData",
        data: params,
        method: "post",
        noLoading: true
    });
}
